// // import React, { useContext, useEffect, useState } from "react";
// // import { AuthContext } from "../context/AuthContext";
// // import { DataContext } from "../context/DataContext";
// // import { useNavigate } from "react-router-dom";
// // import { buildUrlWithUTM } from '../utils/utmUtils.js';
// // import "../styles/application_form.css";
// // import ConfirmPaymentPopup from "./ConfirmPaymentPopup";
// // import { LoadingComponent } from "./LoadingComponent";
// // import { CustomFormInput } from "./CustomFormInput";

// // const ApplicationForm = () => {
// //   const navigate = useNavigate();
// //   const authContext = useContext(AuthContext);
// //   const { getApplicationData, applicationData, setApplicationData, updateApplicationData, dataLoading, setDataError } = useContext(DataContext);
// //   const [currentStepData, setCurrentStepData] = useState(null);
// //   const [currentStep, setCurrentStep] = useState(null);
// //   const [formData, setFormData] = useState({});
// //   const [agreed, setAgreed] = useState(false);
// //   const [showPaymentPopup, setPaymentPopup] = useState(false);

// //   useEffect(() => {
// //     if (applicationData !== null) {
// //       const step = applicationData.steps.find(step => step.step === applicationData.current_application_step);
// //       setCurrentStepData(step);
// //       if (applicationData.status === "Completed") setAgreed(true);
// //     }
// //   }, [applicationData]);

// //   useEffect(() => {
// //     if (currentStepData) {
// //       const newFormData = {};
// //       currentStepData.sections.forEach(section => {
// //         section.fields.forEach(field => {
// //           newFormData[field.field_name] = field.value || "";
// //         });
// //       });
// //       setFormData(newFormData);
// //     }
// //   }, [currentStepData]);

// //   useEffect(() => {
// //     getApplicationData();
// //   }, []);

// //   const handleBackStep = () => {
// //     const updatedStep = applicationData.current_application_step - 1;
// //     setCurrentStep(updatedStep);
// //     setApplicationData(prev => ({ ...prev, current_application_step: updatedStep }));
// //   };

// //   const handlePayment = (e) => {
// //     e.preventDefault();
// //     if (!agreed) {
// //       setDataError({ type: "error", message: "Please confirm the disclaimer" });
// //       return;
// //     }
// //     setPaymentPopup(true);
// //   };

// //   const handleOnPayment = async (e) => {
// //     e.preventDefault();
// //     setPaymentPopup(false);
// //     formData.status = "Completed";
// //     await updateApplicationData({ data: formData });
// //     navigate(buildUrlWithUTM("/portal/application-success"));
// //   };

// //   const handleOnNext = async (e) => {
// //     e.preventDefault();
// //     let totalMissingFields = 0;

// //     // Since we only have one step now (step 0), validate and proceed to payment
// //     for (let section of currentStepData.sections) {
// //       for (let field of section.fields) {
// //         const value = formData[field.field_name];
// //         if (field.required && !value?.toString().trim()) {
// //           setDataError({ type: "error", message: `Please fill ${field.label}` });
// //           totalMissingFields++;
// //           continue;
// //         }
// //         if (value && field.pattern && !new RegExp(field.pattern).test(value)) {
// //           setDataError({ type: "error", message: field.error_message || `Invalid format for ${field.label}` });
// //           totalMissingFields++;
// //         }
// //         if (field.input_type === "year" && (parseInt(value) < field.min_value || parseInt(value) > field.max_value)) {
// //           setDataError({ type: "error", message: "Enter a valid year" });
// //           totalMissingFields++;
// //         }
// //       }
// //     }

// //     if (totalMissingFields > 0) return;

// //     // Save form data and proceed to payment
// //     formData.status = "In Progress";
// //     await updateApplicationData({ data: formData });
// //     setPaymentPopup(true);
// //   };

// //   if (!applicationData) return <LoadingComponent />;

// //   return (
// //     <div className="application-form-container">
// //       <div className="application-header">
// //         <p><span>Candidate Name:</span> {applicationData.name}</p>
// //         <p><span className="label-bold">Application Number:</span> {applicationData.application_id}</p>
// //       </div>

// //       {dataLoading && <LoadingComponent />}

// //       <form className={`form-section ${(applicationData.status === "Completed" || applicationData.status === "Selected") ? "readonly" : ""}`}>
// //         {currentStepData?.sections?.map((section, idx) => (
// //           <div className="section-box" key={idx}>
// //             <div className="section-title">{section.section}</div>
// //             <div className="grid-container">
// //               {section.fields.map((field, fieldIdx) => (
// //                 <CustomFormInput
// //                   key={fieldIdx}
// //                   field={field}
// //                   formData={formData}
// //                   setFormData={setFormData}
// //                   currentStep={currentStep}
// //                 />
// //               ))}
// //             </div>
// //           </div>
// //         ))}

// //         <div className="form-footer">
// //           {/* Hide submit button if application is completed/selected */}
// //           {!(applicationData.status === "Completed" || applicationData.status === "Selected") && (
// //             <button type="submit" className="submit-button" onClick={handleOnNext}>
// //               Proceed to Payment
// //             </button>
// //           )}
// //         </div>
// //       </form>

// //       {showPaymentPopup && (
// //         <ConfirmPaymentPopup onClose={() => setPaymentPopup(false)} onConfirm={handleOnPayment} />
// //       )}
// //     </div>
// //   );
// // };

// // export default ApplicationForm;

// import React, { useContext, useEffect, useState } from "react";
// import { AuthContext } from "../context/AuthContext";
// import { DataContext } from "../context/DataContext";
// import { useNavigate } from "react-router-dom";
// import { buildUrlWithUTM } from '../utils/utmUtils.js';
// import "../styles/application_form.css";
// import ConfirmPaymentPopup from "./ConfirmPaymentPopup";
// import { LoadingComponent } from "./LoadingComponent";
// import { CustomFormInput } from "./CustomFormInput";

// const ApplicationForm = () => {
//   const navigate = useNavigate();
//   const authContext = useContext(AuthContext);
//   const {
//     getApplicationData,
//     applicationData,
//     setApplicationData,
//     updateApplicationData,
//     dataLoading,
//     setDataError
//   } = useContext(DataContext);

//   const [currentStepData, setCurrentStepData] = useState(null);
//   const [currentStep, setCurrentStep] = useState(null);
//   const [formData, setFormData] = useState({});
//   const [agreed, setAgreed] = useState(false);
//   const [showPaymentPopup, setPaymentPopup] = useState(false);

//   useEffect(() => {
//     if (applicationData !== null) {
//       const step = applicationData.steps.find(
//         step => step.step === applicationData.current_application_step
//       );
//       setCurrentStepData(step);
//       if (applicationData.status === "Completed") setAgreed(true);
//     }
//   }, [applicationData]);

//   useEffect(() => {
//     if (currentStepData) {
//       const newFormData = {};
//       currentStepData.sections.forEach(section => {
//         section.fields.forEach(field => {
//           newFormData[field.field_name] = field.value || "";
//         });
//       });
//       setFormData(newFormData);
//     }
//   }, [currentStepData]);

//   useEffect(() => {
//     getApplicationData();
//   }, []);

//   const handleBackStep = () => {
//     const updatedStep = applicationData.current_application_step - 1;
//     setCurrentStep(updatedStep);
//     setApplicationData(prev => ({
//       ...prev,
//       current_application_step: updatedStep
//     }));
//   };

//   const handlePayment = (e) => {
//     e.preventDefault();
//     if (!agreed) {
//       setDataError({
//         type: "error",
//         message: "Please confirm the disclaimer"
//       });
//       return;
//     }
//     setPaymentPopup(true);
//   };

//   const handleOnPayment = async (e) => {
//     e.preventDefault();
//     setPaymentPopup(false);
//     formData.status = "Completed";
//     await updateApplicationData({ data: formData });
//     navigate(buildUrlWithUTM("/portal/application-success"));
//   };

//   const handleOnNext = async (e) => {
//     e.preventDefault();
//     let totalMissingFields = 0;

//     for (let section of currentStepData.sections) {
//       for (let field of section.fields) {
//         const value = formData[field.field_name];

//         if (field.required && !value?.toString().trim()) {
//           setDataError({
//             type: "error",
//             message: `Please fill ${field.label}`
//           });
//           totalMissingFields++;
//           continue;
//         }

//         if (value && field.pattern && !new RegExp(field.pattern).test(value)) {
//           setDataError({
//             type: "error",
//             message: field.error_message || `Invalid format for ${field.label}`
//           });
//           totalMissingFields++;
//         }

//         if (
//           field.input_type === "year" &&
//           (parseInt(value) < field.min_value ||
//             parseInt(value) > field.max_value)
//         ) {
//           setDataError({
//             type: "error",
//             message: "Enter a valid year"
//           });
//           totalMissingFields++;
//         }
//       }
//     }

//     if (totalMissingFields > 0) return;

//     formData.status = "In Progress";
//     await updateApplicationData({ data: formData });
//     setPaymentPopup(true);
//   };

//   if (!applicationData) return <LoadingComponent />;

//   return (
//     <div className="application-form-container">
//       <div className="application-header">
//         <p>
//           <span>Candidate Name:</span> {applicationData.name}
//         </p>
//         <p>
//           <span className="label-bold">Application Number:</span>{" "}
//           {applicationData.application_id}
//         </p>
//       </div>

//       {dataLoading && <LoadingComponent />}

//       <form
//         className={`form-section ${
//           applicationData.status === "Completed" ||
//           applicationData.status === "Selected"
//             ? "readonly"
//             : ""
//         }`}
//       >
//         {currentStepData?.sections?.map((section, idx) => (
//           <div className="section-box" key={idx}>
//             <div className="section-title">{section.section}</div>

//             {/* 👇 Important change: add kyc-grid class only for KYC Details */}
//             <div
//               className={`grid-container ${
//                 section.section === "KYC Details" ? "kyc-grid" : ""
//               }`}
//             >
//               {section.fields.map((field, fieldIdx) => (
//                 <CustomFormInput
//                   key={fieldIdx}
//                   field={field}
//                   formData={formData}
//                   setFormData={setFormData}
//                   currentStep={currentStep}
//                 />
//               ))}
//             </div>
//           </div>
//         ))}

//         <div className="form-footer">
//           {!(
//             applicationData.status === "Completed" ||
//             applicationData.status === "Selected"
//           ) && (
//             <button
//               type="submit"
//               className="submit-button"
//               onClick={handleOnNext}
//             >
//               Proceed to Payment
//             </button>
//           )}
//         </div>
//       </form>

//       {showPaymentPopup && (
//         <ConfirmPaymentPopup
//           onClose={() => setPaymentPopup(false)}
//           onConfirm={handleOnPayment}
//         />
//       )}
//     </div>
//   );
// };

// export default ApplicationForm;

import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { DataContext } from "../context/DataContext";
import { useNavigate } from "react-router-dom";
import { buildUrlWithUTM } from "../utils/utmUtils.js";
import "../styles/application_form.css";
import ConfirmPaymentPopup from "./ConfirmPaymentPopup";
import { LoadingComponent } from "./LoadingComponent";
import { CustomFormInput } from "./CustomFormInput";

const ApplicationForm = () => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const {
    getApplicationData,
    applicationData,
    setApplicationData,
    updateApplicationData,
    dataLoading,
    setDataError,
  } = useContext(DataContext);

  const [currentStepData, setCurrentStepData] = useState(null);
  const [currentStep, setCurrentStep] = useState(null);
  const [formData, setFormData] = useState({});
  const [agreed, setAgreed] = useState(false);
  const [showPaymentPopup, setPaymentPopup] = useState(false);

  useEffect(() => {
    if (applicationData !== null) {
      const step = applicationData.steps.find(
        (step) => step.step === applicationData.current_application_step
      );
      setCurrentStepData(step);
      if (applicationData.status === "Completed") setAgreed(true);
    }
  }, [applicationData]);

  useEffect(() => {
    if (currentStepData) {
      const newFormData = {};
      currentStepData.sections.forEach((section) => {
        section.fields.forEach((field) => {
          newFormData[field.field_name] = field.value || "";
        });
      });
      setFormData(newFormData);
    }
  }, [currentStepData]);

  useEffect(() => {
    getApplicationData();
  }, []);

  const handleBackStep = () => {
    const updatedStep = applicationData.current_application_step - 1;
    setCurrentStep(updatedStep);
    setApplicationData((prev) => ({
      ...prev,
      current_application_step: updatedStep,
    }));
  };

  const handlePayment = (e) => {
    e.preventDefault();
    if (!agreed) {
      setDataError({
        type: "error",
        message: "Please confirm the disclaimer",
      });
      return;
    }
    setPaymentPopup(true);
  };

  const handleOnPayment = async (e) => {
    e.preventDefault();
    setPaymentPopup(false);
    formData.status = "Completed";
    await updateApplicationData({ data: formData });
    navigate(buildUrlWithUTM("/portal/application-success"));
  };

  const handleOnNext = async (e) => {
    e.preventDefault();
    let totalMissingFields = 0;

    for (let section of currentStepData.sections) {
      for (let field of section.fields) {
        const value = formData[field.field_name];

        if (field.required && !value?.toString().trim()) {
          setDataError({
            type: "error",
            message: `Please fill ${field.label}`,
          });
          totalMissingFields++;
          continue;
        }

        if (value && field.pattern && !new RegExp(field.pattern).test(value)) {
          setDataError({
            type: "error",
            message: field.error_message || `Invalid format for ${field.label}`,
          });
          totalMissingFields++;
        }

        if (
          field.input_type === "year" &&
          (parseInt(value) < field.min_value ||
            parseInt(value) > field.max_value)
        ) {
          setDataError({
            type: "error",
            message: "Enter a valid year",
          });
          totalMissingFields++;
        }
      }
    }

    if (totalMissingFields > 0) return;

    // If status is "Selected", set it to "Payment" after filling all details
    if (applicationData.status === "Selected") {
      formData.status = "Payment";
    } else {
      formData.status = "In Progress";
    }
    await updateApplicationData({ data: formData });
    setPaymentPopup(true);
  };

  if (!applicationData) return <LoadingComponent />;

  return (
    <div className="application-form-container">
      <div className="application-header">
        <p>
          <span>Candidate Name:</span> {applicationData.name}
        </p>
        <p>
          <span className="label-bold">Application Number:</span>{" "}
          {applicationData.application_id}
        </p>
      </div>

      {dataLoading && <LoadingComponent />}

      <form
        className={`form-section ${
          applicationData.status === "Completed"
            ? "readonly"
            : ""
        }`}
      >
        {currentStepData?.sections?.map((section, idx) => (
          <div className="section-box" key={idx}>
            <div className="section-title">{section.section}</div>

            {/* Grid gets an extra class so we can control its columns */}
            <div
              className={`grid-container ${
                section.section === "KYC Details" ? "kyc-grid" : 
                section.section === "Personal Details" ? "personal-details-grid" : ""
              }`}
            >
              {section.fields.map((field, fieldIdx) => (
                <CustomFormInput
                  key={fieldIdx}
                  field={field}
                  formData={formData}
                  setFormData={setFormData}
                  currentStep={currentStep}
                />
              ))}
            </div>
          </div>
        ))}

        <div className="form-footer">
          {applicationData.status !== "Completed" && (
            <button
              type="submit"
              className="submit-button"
              onClick={handleOnNext}
            >
              Ready to Submit
            </button>
          )}
        </div>
      </form>

      {showPaymentPopup && (
        <ConfirmPaymentPopup
          onClose={() => setPaymentPopup(false)}
          onConfirm={handleOnPayment}
        />
      )}
    </div>
  );
};

export default ApplicationForm;
